import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DepositCryptoComponent } from 'src/app/feature/modules/report/components/deposit-crypto/deposit-crypto.component';
import { DepositRialComponent } from 'src/app/feature/modules/report/components/deposit-rial/deposit-rial.component';
import { WithdrawCryptoComponent } from 'src/app/feature/modules/report/components/withdraw-crypto/withdraw-crypto.component';
import { WithdrawRialComponent } from 'src/app/feature/modules/report/components/withdraw-rial/withdraw-rial.component';
import { WithdrawTreasuryComponent } from './components/withdraw-treasury/withdraw-treasury.component';
import { DepositTreasuryComponent } from './components/deposit-treasury/deposit-treasury.component';
import { GeneralReportsComponent } from './components/general-reports/general-reports.component';
import { ReportPageComponent } from './components/general-reports/report-page/report-page.component';
import { ReportAccessListComponent } from './components/general-reports/report-access-list/report-access-list.component';
import { ReportQueueComponent } from './components/general-reports/report-queue/report-queue.component';

const routes: Routes = [
  {
    path: 'general',
    component: GeneralReportsComponent
  },
  {
    path: `general/:id`,
    component: ReportPageComponent
  },
  {
    path: `access-list`,
    component: ReportAccessListComponent
  },
  {
    path: `queue-list`,
    component: ReportQueueComponent
  },
  {
    path: 'deposit/crypto',
    component: DepositCryptoComponent
  },
  {
    path: 'deposit/rial',
    component: DepositRialComponent
  },
  {
    path: 'withdraw/crypto',
    component: WithdrawCryptoComponent
  },
  {
    path: 'withdraw/rial',
    component: WithdrawRialComponent
  },
  {
    path: 'treasury/withdraw',
    component: WithdrawTreasuryComponent
  },
  {
    path: 'treasury/deposit',
    component: DepositTreasuryComponent
  },
  {
    path: 'manual-deposit',
    loadComponent: () => import('../manual-transaction/manual-transaction/manual-transaction.component').then(c => c.ManualTransactionComponent)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportRoutingModule {
}
